import { render, staticRenderFns } from "./EmployeePersonalData.vue?vue&type=template&id=8218a2f0&scoped=true&"
import script from "./EmployeePersonalData.vue?vue&type=script&lang=js&"
export * from "./EmployeePersonalData.vue?vue&type=script&lang=js&"
import style0 from "./EmployeePersonalData.vue?vue&type=style&index=0&id=8218a2f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8218a2f0",
  null
  
)

export default component.exports